import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const KURKUMlist2 = () => {
  const { mapel } = useParams();
  const [TPData, setTPData] = useState([]);
  const [filterKelas, setFilterKelas] = useState("");
  const [filterSemester, setFilterSemester] = useState("");
  const [filterMapel, setFilterMapel] = useState("");
  const [filterRombel, setFilterRombel] = useState(""); // state baru

  useEffect(() => {
    fetchTPData();
  }, []);

  const fetchTPData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/tp`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setTPData(response.data);
    } catch (error) {
      console.error("Error fetching TP data:", error);
    }
  };

  const filteredTPData = TPData.filter((item) => {
    if (filterKelas && item.kelas !== filterKelas) return false;
    if (filterSemester && item.semester !== filterSemester) return false;
    if (filterMapel && item.mapel !== filterMapel) return false;
    if (filterRombel && item.rombel !== filterRombel) return false; // filter rombel
    return true;
  });

  const isAllFiltersEmpty =
    filterKelas.trim() === "" &&
    filterSemester.trim() === "" &&
    filterMapel.trim() === "" &&
    filterRombel.trim() === "";

  const truncateText = (text, maxWords) => {
    const words = text.split(" ");
    if (words.length > maxWords) {
      return words.slice(0, maxWords).join(" ") + " ...";
    }
    return text;
  };

  return (
    <div className="bg-white rounded-lg p-5 m-5 drop-shadow-lg mx-7 md:mx-5">
      <div className="flex justify-center">
        <h2 className="font-bold text-2xl">Daftar TP</h2>
      </div>

      <div>
        <Link to={`/addTP`}>
          <button className="bg-blue-400 px-3 py-2 rounded-lg font-bold text-white hover:bg-blue-600 mb-5">
            Tambah TP
          </button>
        </Link>
      </div>

      <div className="grid gap-4 bg-white p-5 rounded-lg border border-slate-300 shadow-md">
        {/* Pilihan Kelas */}
        <div className="flex items-center">
          <label className="w-1/4 font-medium">Kelas:</label>
          <select
            value={filterKelas}
            onChange={(e) => setFilterKelas(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
          >
            <option value="">Semua Kelas</option>
            {[1, 2, 3, 4, 5, 6].map((kelas) => (
              <option key={kelas} value={kelas}>
                {kelas}
              </option>
            ))}
          </select>
        </div>

        {/* Pilihan Semester */}
        <div className="flex items-center">
          <label className="w-1/4 font-medium">Semester:</label>
          <select
            value={filterSemester}
            onChange={(e) => setFilterSemester(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
          >
            <option value="">Semua Semester</option>
            {[1, 2].map((semester) => (
              <option key={semester} value={semester}>
                {semester}
              </option>
            ))}
          </select>
        </div>

        {/* Pilihan Mata Pelajaran */}
        <div className="flex items-center">
          <label className="w-1/4 font-medium">Mata Pelajaran:</label>
          <select
            value={filterMapel}
            onChange={(e) => setFilterMapel(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
          >
            <option value="">Semua Mata Pelajaran</option>
            {[
              "MTK",
              "BIndo",
              "BIng",
              "IPAS",
              "PKN",
              "PJOK",
              "MULOK",
              "SENIBUDAYA",
              "PAI",
              "Koding",
            ].map((mapel) => (
              <option key={mapel} value={mapel}>
                {mapel}
              </option>
            ))}
          </select>
        </div>

        {/* Pilihan Rombel */}
        <div className="flex items-center">
          <label className="w-1/4 font-medium">Rombel:</label>
          <select
            value={filterRombel}
            onChange={(e) => setFilterRombel(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
          >
            <option value="">Semua Rombel</option>
            {["A", "B", "C", "D"].map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>
      </div>

      {isAllFiltersEmpty && <p>Tidak ada data yang dipilih.</p>}
      {!isAllFiltersEmpty && filteredTPData.length === 0 && (
        <p>Tidak ada data yang sesuai dengan filter yang dipilih.</p>
      )}
      <div className="overflow-x-auto">
        {!isAllFiltersEmpty && filteredTPData.length > 0 && (
          <table className="min-w-full bg-white mt-5 border border-slate-300">
            <thead>
              <tr>
                <th className="py-2 border">TP</th>
                <th className="py-2 border">Deskripsi</th>
                <th className="py-2 border">Rombel</th>
                <th className="py-2 border">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {filteredTPData.map((item) => (
                <tr key={item._id}>
                  <td className="border px-4 py-2">
                    <ul>
                      {item.TP.map((tp, index) => (
                        <li key={index}>TP {index + 1}:</li>
                      ))}
                    </ul>
                  </td>
                  <td className="border px-4 py-2">
                    {item.TP.map((tp, index) => (
                      <p key={index}>{truncateText(tp.isiTP, 8)}</p>
                    ))}
                  </td>
                  <td className="border px-4 py-2 text-center">
                    {item.rombel}
                  </td>
                  <td className="border px-4 py-2">
                    <div className="flex justify-center">
                      <Link
                        to={`/editTP/${item._id}`}
                        state={{ from: `/guru/elearning-guru/${mapel}` }}
                      >
                        <button className="bg-green-500 text-white px-4 py-2 rounded">
                          Edit
                        </button>
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default KURKUMlist2;
